import { createSelector, createSelectorCreator, defaultMemoize } from "reselect";

import isEqual from "lodash/isEqual";

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

export const mapState = state => state.appState.mapRef;
export const mapObject = state => state.appState.mapRef.mapObject;
export const inEditGeo = state => state.appState.mapRef.inEditGeo;

export const replayMapState = state => state.appState.replayMapRef;
export const replayMapObject = state => state.appState.replayMapRef.mapObject;
const baseMapRefState = state =>
	state.replayMapState
		? state.replayMapState.replayBaseMap.mapRef
		: state.mapState
			? state.mapState.baseMap.mapRef
			: null;

export const activeEntitiesSelector = createSelector(mapState, state => {
	return state.entities;
});

export const activeReplayEntitiesSelector = createSelector(replayMapState, state => {
	return state.entities;
});

export const mapSelector = () => {
	return createDeepEqualSelector(baseMapRefState, result => {
		return result;
	});
};

export const mapStateSelector = () => {
	return createDeepEqualSelector(mapState, result => {
		return result;
	});
};

const selectReplayEntities = state => state?.appState?.replayMapRef?.entities || {};

const findEntityInReplay = (entities, entityId, expectedType) => {
	if (!entities || !entityId) return null;

	for (const bucket of Object.values(entities)) {
		if (!bucket || typeof bucket !== "object") continue;

		const candidate = bucket[entityId];
		if (!candidate) continue;

		if (!expectedType) return candidate;

		const t = candidate.entityType || candidate.type;
		if (t === expectedType) return candidate;
	}

	return null;
};

export const getReplayContextActivityEntity = (notificationContext, forReplay) => {
	// Always return a selector fn
	if (!forReplay) {
		return () => [];
	}
	return createDeepEqualSelector([selectReplayEntities], entities => {
		const activity = notificationContext?.entity?.activity;
		const contextEntities = activity?.contextEntities || [];

		// 1) Get ALL track context entities
		const trackCtxList = contextEntities.filter(e => e?.entityType === "track");
		if (trackCtxList.length === 0) return [];

		// 2) Extract ids (guard against missing ids)
		const trackIds = trackCtxList
			.map(t => t?.id) // adjust if your payload uses entityId/targetId/etc
			.filter(Boolean);

		if (trackIds.length === 0) return [];

		// 3) Look them all up in replay entities
		const trackEntities = trackIds.map(id => findEntityInReplay(entities, id, "track")).filter(Boolean);

		return trackEntities; // array of track objs found in replayMapRef.entities
	});
};
